// extracted by mini-css-extract-plugin
export var childrenContainer = "_4e-0";
export var virtualScrollArea = "_4e-1";